<template>
    <section class="scrollable">
        <h3 class="section-title">Рецепты</h3>
        <div class="text-container text-container-relative">
            <div class="text-main text-main-recipes">
                <p>Мы собрали для вас 20 лучших рецепты блюд, приготовленных на гриле. Выбери любимый рецепт или порадуй
                близких и друзей умением готовить разнообразные и вкусные блюда на пикнике!</p>
            </div>
            <ul class="recipes-btn">
                <li>
                    <a href="#" @click.prevent="toggleType('meat')" class="btn" :class="{'recipes-active': (type=='meat')}">мясо</a>
                </li>
                <li>
                    <a href="#" @click.prevent="toggleType('no-meat')" class="btn" :class="{'recipes-active': (type=='no-meat')}">без мяса</a>
                </li>
                <li>
                    <a href="#" @click.prevent="toggleType('all')" class="btn" :class="{'recipes-active': (type=='all')}">всё</a>
                </li>
            </ul>
        </div>
        <div class="recipes-wrap">
            <div class="recipes-container">
                <div class="clear">
                    <div class="recipes-col">
                        <Recipe v-for="(rec, index) in recipes" v-if="index % 2 == 0" :key="index" :recipe="rec" :index="index"></Recipe>
                    </div>
                    <div class="recipes-col">
                        <Recipe v-for="(rec, index) in recipes" v-if="index % 2 !=0" :key="index" :recipe="rec" :index="index"></Recipe>
                    </div>
                </div>

                <div class="recipe-button">
                    <a href="#" class="btn-top" @click.prevent="up">в начало <Arrow></Arrow></a>
                </div>

            </div>
        </div>
    </section>
</template>

<script>

    import {TweenMax} from 'gsap';
    import Recipe from '@/components/common/Recipe';
    import Storage from '@/store/storage';
    import Arrow from '../../assets/svg/arrow.svg';
    import Helpers from '@/tools/Helpers';


    export default {
        name: 'Recipes',

        props: ['recipe','index'],

        data () {
            return {
                type: 'all',
            }
        },
        mounted(){
            if(this.$route.path == '/recipes'){

                function hideTitle() {
                    if(Helpers.isMobile()){
                        return
                    }
                        var scrolled = window.pageYOffset || document.documentElement.scrollTop;
                    if(scrolled>0){
                        document.querySelector('.menu-btn.left').classList.add('hide');
                    }else{
                        document.querySelector('.menu-btn.left').classList.remove('hide');
                    }
                };

                window.onscroll = function() {
                    hideTitle()
                }
            }

        },
        methods: {
            toggleType(type) {
                this.type = type;
                ga('send', 'event', 'click', 'show', 'Tab click: ' + this.type);
            },
            up() {
                var t;
                var e = Math.max(document.body.scrollTop, document.documentElement.scrollTop);
                return e > 0 ? (window.scrollBy(0, (e + 100) / -10), t = setTimeout(this.up, 20)) : clearTimeout(t), !1;
            },
            gaUp(){
                ga('send', 'event', 'click', 'show', 'Click to Up');
            }

        },
        computed: {
            recipes() {
                let self = this;
                return Storage.filter((rec, index) => {
                    return rec.type == self.type || self.type == 'all'
                });
            }
        },
        components: {
            Recipe,
            Arrow
        }
    }

</script>





// WEBPACK FOOTER //
// Recipes.vue?7006798b